import React from "react"
import PropTypes from "prop-types"
import { Avatar, Rating } from "@mui/material"
import { formatWhen } from "./datetime"

/**
 * One review: author initial, stars, when, and the comment. `actions` is an
 * optional slot (edit / delete buttons) rendered at the top right.
 */
export default function ReviewItem({ review, actions }) {
    const name = review.author_name || "Student"

    return (
        <article className="flex gap-3 border-b border-slate-100 py-4 last:border-b-0">
            <Avatar sx={{ width: 36, height: 36, fontSize: 15, bgcolor: "#334155" }}>
                {name.charAt(0).toUpperCase()}
            </Avatar>
            <div className="min-w-0 flex-1">
                <div className="flex items-start justify-between gap-2">
                    <div className="min-w-0">
                        <p className="truncate text-sm font-semibold text-slate-800">
                            {name}
                            {review.is_mine && (
                                <span className="ml-2 rounded-full bg-indigo-50 px-2 py-0.5 text-[11px] font-medium text-indigo-600">
                                    You
                                </span>
                            )}
                        </p>
                        <div className="mt-0.5 flex flex-wrap items-center gap-2">
                            <Rating value={Number(review.rating) || 0} size="small" readOnly />
                            <span className="text-xs text-slate-400">
                                {formatWhen(review.updated_at || review.created_at)}
                            </span>
                        </div>
                    </div>
                    {actions && <div className="flex shrink-0 items-center">{actions}</div>}
                </div>
                {review.comment && (
                    <p className="mt-2 whitespace-pre-line break-words text-sm text-slate-600">
                        {review.comment}
                    </p>
                )}
            </div>
        </article>
    )
}

ReviewItem.propTypes = {
    review: PropTypes.object.isRequired,
    actions: PropTypes.node
}
